"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Earth2: ['earth-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.953,4.026a.5.5,0,0,0-.844.162L19,7.258A2,2,0,0,1,17.391,8.5H14.553a.5.5,0,0,0-.385.72l.885,2.28a.5.5,0,0,0,.447.277h.829a.5.5,0,0,1,.447.723L14,18.192a2.027,2.027,0,0,1-3.867-.249l-.991-4.167a.5.5,0,0,0-.447-.276H8.25a3.25,3.25,0,0,1,0-6.5h4.1a.5.5,0,0,0,.5-.5V5.354A2,2,0,0,0,11.6,3.5l-.284-.114a.5.5,0,0,1-.063-.9l2.721-1.4a.5.5,0,0,0-.15-.939A11.645,11.645,0,0,0,12,0a12.026,12.026,0,1,0,8.953,4.026Z']],
  EarthAdd: ['earth-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.967,22.108a.5.5,0,0,0-.339-.206,9.975,9.975,0,0,1-2.987-.914.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.492,4.492,0,0,0,1.266-1.779,7.851,7.851,0,0,1,.264-.965,4.448,4.448,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.554,2.554,0,0,1,1.358.408.246.246,0,0,0,.187.032A7.922,7.922,0,0,1,23.476,12.2.3.3,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24a.3.3,0,0,0,.2-.524A7.962,7.962,0,0,1,10.967,22.108Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.5H19a.5.5,0,0,0-.5.5v1a1,1,0,0,1-2,0V19a.5.5,0,0,0-.5-.5H15a1,1,0,0,1,0-2h1a.5.5,0,0,0,.5-.5V15a1,1,0,0,1,2,0v1a.5.5,0,0,0,.5.5h1a1,1,0,0,1,0,2Z']],
  EarthCash: ['earth-cash', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.967,22.108a.5.5,0,0,0-.339-.206,9.975,9.975,0,0,1-2.987-.914.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.492,4.492,0,0,0,1.266-1.779,7.851,7.851,0,0,1,.264-.965,4.448,4.448,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.54,2.54,0,0,1,1.283.362.5.5,0,0,0,.355.059A7.857,7.857,0,0,1,17.5,9.5a7.972,7.972,0,0,1,5.976,2.7A.3.3,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24a.3.3,0,0,0,.2-.524A7.962,7.962,0,0,1,10.967,22.108Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm.95,10.2a.249.249,0,0,0-.2.245v.308a.75.75,0,0,1-1.5,0V21.5a.25.25,0,0,0-.25-.25H16a.75.75,0,0,1,0-1.5h2.033a.592.592,0,0,0,.22-1.141l-2.063-.825a2.084,2.084,0,0,1,.36-3.981.249.249,0,0,0,.2-.245V13.25a.75.75,0,0,1,1.5,0v.25a.25.25,0,0,0,.25.25H19a.75.75,0,0,1,0,1.5H16.967a.592.592,0,0,0-.22,1.141l2.063.825a2.084,2.084,0,0,1-.36,3.981Z']],
  EarthEdit: ['earth-edit', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.429,17.522A4.455,4.455,0,0,0,5.565,9.654H2.679a.249.249,0,0,1-.2-.1.253.253,0,0,1-.043-.215,9.883,9.883,0,0,1,14.4-6.092.247.247,0,0,1-.121.463H14.229a2.723,2.723,0,1,0,0,5.446,2.579,2.579,0,0,1,2.2,1.245l.576.961a.5.5,0,0,0,.775.1l.579-.579a4.09,4.09,0,0,1,2.928-1.238,3.957,3.957,0,0,1,1.65.361.5.5,0,0,0,.69-.552A11.879,11.879,0,1,0,7.389,22.831l.157.077v-.02a11.653,11.653,0,0,0,1.439.475.5.5,0,0,0,.6-.355l.013-.047.257-.9a.494.494,0,0,0-.352-.615,9.74,9.74,0,0,1-1.822-.666.247.247,0,0,1-.139-.222V19.419A2.47,2.47,0,0,1,8.429,17.522Z', 'M12.733,20.085a.5.5,0,0,0-.826.214l-.878,3.07a.5.5,0,0,0,.613.612l3.069-.877a.494.494,0,0,0,.214-.826Z', 'M23.122,15.559a2.6,2.6,0,0,0,0-3.67,2.629,2.629,0,0,0-3.716.045L13.044,18.3a.494.494,0,0,0,0,.7l2.97,2.971a.495.495,0,0,0,.7,0Z']],
  EarthModel1: ['earth-model-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.2.4a1.245,1.245,0,0,0-1.837,1.682A9.713,9.713,0,0,1,3.668,15.83a1.245,1.245,0,1,0-1.676,1.841A12.1,12.1,0,0,0,8.327,20.7a.249.249,0,0,1,.04.483,12.3,12.3,0,0,0-1.7.7A1.121,1.121,0,0,0,7.176,24H17.709a1.121,1.121,0,0,0,.5-2.123,12.621,12.621,0,0,0-3.983-1.22.25.25,0,0,1-.047-.483A12.2,12.2,0,0,0,19.2.4Z', 'M10.2,16.611a7.97,7.97,0,1,0-7.97-7.969A7.979,7.979,0,0,0,10.2,16.611Zm.5-13.7a.747.747,0,0,1,0,1.494A4.738,4.738,0,0,0,5.967,9.138a.748.748,0,0,1-1.495,0A6.234,6.234,0,0,1,10.7,2.912Z']],
  EarthDownload: ['earth-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.814,21.875a.5.5,0,0,0-.338-.219,9.848,9.848,0,0,1-2.932-.945V19.419a2.468,2.468,0,0,1,.884-1.9A4.455,4.455,0,0,0,5.564,9.654h-3.2A9.884,9.884,0,0,1,17.585,3.713H14.228a2.723,2.723,0,1,0,0,5.446,2.538,2.538,0,0,1,1.507.509.5.5,0,0,0,.378.09,7.863,7.863,0,0,1,7.095,2.39.39.39,0,0,0,.673-.267A11.881,11.881,0,1,0,7.387,22.831l.157.077v-.02A11.824,11.824,0,0,0,12,23.763a.194.194,0,0,0,.13-.337A7.98,7.98,0,0,1,10.814,21.875Z', 'M17.445,11.129a6.436,6.436,0,1,0,6.436,6.435A6.443,6.443,0,0,0,17.445,11.129Zm2.367,7.24-1.98,2.475a.5.5,0,0,1-.774,0l-1.98-2.475a.5.5,0,0,1,.387-.8h.742a.494.494,0,0,0,.5-.5V14.594a.743.743,0,0,1,1.486,0v2.475a.494.494,0,0,0,.5.5h.742a.5.5,0,0,1,.387.8Z']],
  EarthLock: ['earth-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.249,22.5v-.25A.249.249,0,0,0,12,22a9.9,9.9,0,0,1-4.212-.942.5.5,0,0,1-.288-.453v-.992A2.492,2.492,0,0,1,8.393,17.7,4.5,4.5,0,0,0,5.5,9.75H2.915a.5.5,0,0,1-.478-.645A9.984,9.984,0,0,1,15.889,2.79a.5.5,0,0,1-.195.96H14.25a2.75,2.75,0,0,0,0,5.5,2.564,2.564,0,0,1,1.826.781.5.5,0,0,0,.6.084A4.683,4.683,0,0,1,19,9.5a4.756,4.756,0,0,1,4.74,4.426.122.122,0,0,0,.07.1h0l0,0A11.993,11.993,0,1,0,7.328,23.053l.027.012.127.063a.011.011,0,0,0,.012,0,.011.011,0,0,0,.006-.01A11.927,11.927,0,0,0,12,24a.421.421,0,0,0,.4-.551A3.072,3.072,0,0,1,12.249,22.5Z', 'M22.874,15.547a.5.5,0,0,1-.375-.484V14.25a3.5,3.5,0,0,0-7,0v.813a.5.5,0,0,1-.375.484A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.874,15.547ZM19,21.25a1,1,0,1,1,1-1A1,1,0,0,1,19,21.25ZM20.5,15a.5.5,0,0,1-.5.5H18a.5.5,0,0,1-.5-.5v-.75a1.5,1.5,0,1,1,3,0Z']],
  EarthRefresh: ['earth-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.553,18.709a.981.981,0,0,0-1.245.61,4.008,4.008,0,0,1-6.6,1.581.491.491,0,0,1-.006-.7l1.517-1.516a.491.491,0,0,0-.346-.837H11.51a.49.49,0,0,0-.49.49v4.368a.49.49,0,0,0,.836.347l.775-.776a.491.491,0,0,1,.69,0,5.963,5.963,0,0,0,9.842-2.32A.98.98,0,0,0,22.553,18.709Z', 'M9.006,23.125a.434.434,0,0,0,.544-.419v-1.1a.491.491,0,0,0-.35-.47A9.775,9.775,0,0,1,7.59,20.5V19.221a2.445,2.445,0,0,1,.875-1.878A4.41,4.41,0,0,0,5.63,9.555H2.46a9.783,9.783,0,0,1,15.068-5.88H14.205a2.7,2.7,0,0,0,0,5.39,2.54,2.54,0,0,1,1.849.82,7.511,7.511,0,0,1,1.186-.1,7.426,7.426,0,0,1,4.234,1.331.321.321,0,0,0,.41-.037,1.947,1.947,0,0,1,1.386-.574.376.376,0,0,0,.371-.428A11.761,11.761,0,1,0,7.435,22.6l.155.078v-.021A11.691,11.691,0,0,0,9.006,23.125Z', 'M23.76,12.47a.491.491,0,0,0-.837-.347l-.831.832a.491.491,0,0,1-.688.005,5.973,5.973,0,0,0-9.828,2.347.98.98,0,0,0,1.855.634A4.007,4.007,0,0,1,20,14.335a.49.49,0,0,1,.01.7l-1.455,1.454a.491.491,0,0,0,.347.837H23.27a.491.491,0,0,0,.49-.49Z']],
  EarthPin1: ['earth-pin-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.5,9.5,0,0,0,8,18.119a2.5,2.5,0,0,1,1.218,1.222l1.873,4.076a1,1,0,0,0,1.817,0l1.876-4.08A2.5,2.5,0,0,1,16,18.118,9.5,9.5,0,0,0,12,0Zm0,16A6.493,6.493,0,0,1,8.414,4.09a.5.5,0,0,1,.777.416V7.938a.814.814,0,0,1-.488.746A1.219,1.219,0,0,0,7.971,9.8v.813a1.22,1.22,0,0,0,2.3.564,1.051,1.051,0,0,1,.93-.564h2.46a.814.814,0,0,0,.814-.813l.023-1.66a.812.812,0,0,0-.813-.813H13.28a.814.814,0,0,1-.813-.814L12.484,6a1.008,1.008,0,0,1,1.008-.992A1.008,1.008,0,0,0,14.5,4a.318.318,0,0,1,.463-.283A6.5,6.5,0,0,1,12,16Z']],
  EarthStar: ['earth-star', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.862,22.417a.5.5,0,0,0-.419-.548,9.967,9.967,0,0,1-2.8-.881.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.484,4.484,0,0,0,1.118-1.434,2.556,2.556,0,0,1,.435-1.523A4.423,4.423,0,0,0,10,14.25a4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.581,2.581,0,0,1,1.511.5.5.5,0,0,0,.518.042A2.7,2.7,0,0,1,17.5,9.5a2.778,2.778,0,0,1,2.491,1.526l.045.1.895,2.075a.5.5,0,0,0,.459.3h1.35a2.77,2.77,0,0,1,.593.064.5.5,0,0,0,.6-.436A10.76,10.76,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02a11.894,11.894,0,0,0,2.846.757.5.5,0,0,0,.558-.6A2.754,2.754,0,0,1,10.862,22.417Z', 'M22.74,15H20.4a.5.5,0,0,1-.459-.3l-1.279-2.966-.013-.027a1.293,1.293,0,0,0-2.317.027L15.055,14.7a.5.5,0,0,1-.459.3H12.258a1.231,1.231,0,0,0-1.166.759,1.272,1.272,0,0,0,.32,1.4l2.059,1.834a.5.5,0,0,1,.126.573L12.446,22.21a1.255,1.255,0,0,0,.314,1.452,1.278,1.278,0,0,0,1.506.166l2.989-1.684a.5.5,0,0,1,.491,0l2.99,1.684a1.277,1.277,0,0,0,1.506-.166,1.255,1.255,0,0,0,.315-1.451l-1.151-2.649a.5.5,0,0,1,.125-.573l2.078-1.851a1.264,1.264,0,0,0,.3-1.378A1.234,1.234,0,0,0,22.74,15Z']],
  EarthSearch: ['earth-search', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,22a9.924,9.924,0,0,1-4.36-1.012.251.251,0,0,1-.14-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.516,4.516,0,0,0,1.119-1.435,6.969,6.969,0,0,1,.461-2.277A4.492,4.492,0,0,0,5.5,9.75H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.588,2.588,0,0,1,1.253.329,6.922,6.922,0,0,1,7.431,4.174.5.5,0,0,0,.955-.128A12,12,0,1,0,7.341,23.059l.159.078v-.02a11.919,11.919,0,0,0,6.125.772.5.5,0,0,0,.128-.955,7.047,7.047,0,0,1-1.445-.834.492.492,0,0,0-.3-.1Z', 'M21.362,19.949a.5.5,0,0,1-.076-.609,5.539,5.539,0,1,0-1.946,1.946.5.5,0,0,1,.609.077l2.344,2.344a1,1,0,0,0,1.414-1.414ZM13,16.529a3.529,3.529,0,1,1,3.529,3.529A3.533,3.533,0,0,1,13,16.529Z']],
  EarthShare: ['earth-share', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,21.25a2.752,2.752,0,0,0-2.75-2.75,2.724,2.724,0,0,0-1.785.668.5.5,0,0,1-.513.086l-2.43-.972a.035.035,0,0,1-.022-.032c0-.053,0-.1-.006-.156a.5.5,0,0,1,.241-.469l2.567-1.54a.5.5,0,0,1,.521,0,2.687,2.687,0,0,0,1.427.412,2.75,2.75,0,1,0-2.75-2.75c0,.052,0,.1.006.155a.5.5,0,0,1-.241.469L15.7,15.915a.5.5,0,0,1-.522,0A2.689,2.689,0,0,0,13.75,15.5a2.75,2.75,0,0,0,0,5.5,2.724,2.724,0,0,0,1.785-.668.5.5,0,0,1,.513-.086l2.431.973a.033.033,0,0,1,.021.031,2.75,2.75,0,0,0,5.5,0Z', 'M16.229,21.934a.5.5,0,0,0-.432.029,4.129,4.129,0,0,1-3.938.073.485.485,0,0,0-.207-.053,9.946,9.946,0,0,1-4.011-1,.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7,4.5,4.5,0,0,0,5.5,9.75H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.6,2.6,0,0,1,2.222,1.258l.466.777a.5.5,0,0,0,.838.029A4.231,4.231,0,0,1,21.25,9.5a4.117,4.117,0,0,1,1.738.384.5.5,0,0,0,.7-.566A11.995,11.995,0,1,0,7.341,23.059l.159.078v-.02a11.874,11.874,0,0,0,9.393-.175.5.5,0,0,0,.279-.582.112.112,0,0,0-.067-.075Z']],
  EarthTime: ['earth-time', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.967,22.108a.5.5,0,0,0-.339-.206A9.983,9.983,0,0,1,7.5,20.918v-1.3A2.492,2.492,0,0,1,8.393,17.7a4.482,4.482,0,0,0,1.264-1.775,7.868,7.868,0,0,1,.266-.972,4.423,4.423,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.265a9.982,9.982,0,0,1,15.375-6H14.25a2.75,2.75,0,0,0,0,5.5,2.527,2.527,0,0,1,1.282.362.5.5,0,0,0,.354.058A7.874,7.874,0,0,1,17.5,9.5a7.97,7.97,0,0,1,5.977,2.7A.3.3,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24a.3.3,0,0,0,.2-.524A7.968,7.968,0,0,1,10.967,22.108Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm0,11A4.5,4.5,0,1,1,22,17.5,4.5,4.5,0,0,1,17.5,22Z', 'M19.5,16.5h-.75a.249.249,0,0,1-.25-.25V15a1,1,0,0,0-2,0v2.5a1,1,0,0,0,1,1h2a1,1,0,0,0,0-2Z']],
  EarthSync: ['earth-sync', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.343,21.573a.491.491,0,0,0-.326-.235A9.8,9.8,0,0,1,7.59,20.5V19.221a2.445,2.445,0,0,1,.875-1.878A4.4,4.4,0,0,0,9.542,15.97,7.722,7.722,0,0,1,9.96,14.7a4.349,4.349,0,0,0,.08-.731,4.415,4.415,0,0,0-4.41-4.41H2.46a9.783,9.783,0,0,1,15.068-5.88H14.205a2.7,2.7,0,0,0,0,5.39,2.52,2.52,0,0,1,1.854.835.489.489,0,0,0,.4.158q.29-.023.584-.023a7.652,7.652,0,0,1,4.022,1.127.489.489,0,0,0,.6-.071l.216-.216A1.947,1.947,0,0,1,23.27,10.3a.339.339,0,0,0,.335-.393A11.756,11.756,0,1,0,7.435,22.6l.155.078v-.021a11.751,11.751,0,0,0,3.058.785.49.49,0,0,0,.434-.8A7.589,7.589,0,0,1,10.343,21.573Z', 'M23.457,11.808a.49.49,0,0,0-.534.107l-1.107,1.106a.489.489,0,0,1-.669.022,6.247,6.247,0,1,0,.779,8.607A.98.98,0,1,0,20.4,20.426a4.287,4.287,0,1,1-.709-6.05.491.491,0,0,1,.044.732l-1.175,1.174a.49.49,0,0,0,.347.837H23.27a.49.49,0,0,0,.49-.49V12.261A.491.491,0,0,0,23.457,11.808Z']],
  EarthUpload: ['earth-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.814,21.875a.5.5,0,0,0-.338-.219,9.848,9.848,0,0,1-2.932-.945V19.419a2.468,2.468,0,0,1,.884-1.9A4.455,4.455,0,0,0,5.564,9.654h-3.2A9.884,9.884,0,0,1,17.585,3.713H14.228a2.723,2.723,0,1,0,0,5.446,2.538,2.538,0,0,1,1.507.509.5.5,0,0,0,.378.09,7.863,7.863,0,0,1,7.095,2.39.39.39,0,0,0,.673-.267A11.881,11.881,0,1,0,7.387,22.831l.157.077v-.02A11.824,11.824,0,0,0,12,23.763a.194.194,0,0,0,.13-.337A7.98,7.98,0,0,1,10.814,21.875Z', 'M17.445,11.129a6.436,6.436,0,1,0,6.435,6.435A6.442,6.442,0,0,0,17.445,11.129Zm2.426,6.154a.494.494,0,0,1-.446.281h-.5a.5.5,0,0,0-.5.5v2.476a.99.99,0,1,1-1.98,0V18.059a.5.5,0,0,0-.5-.5h-.495a.5.5,0,0,1-.386-.8l1.98-2.475a.512.512,0,0,1,.773,0l1.981,2.475A.492.492,0,0,1,19.871,17.283Z']],
  EarthWarning: ['earth-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.393,17.7A4.5,4.5,0,0,0,5.5,9.75H2.265a9.982,9.982,0,0,1,15.375-6H14.25a2.75,2.75,0,0,0,0,5.5,2.565,2.565,0,0,1,1.83.788.5.5,0,0,0,.523.123A2.717,2.717,0,0,1,17.5,10a2.938,2.938,0,0,1,2.609,1.573h0l2.313,4.406a.5.5,0,0,0,.914-.068A11.843,11.843,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02a11.751,11.751,0,0,0,1.441.478.5.5,0,0,0,.62-.564,2.924,2.924,0,0,1-.009-.886.5.5,0,0,0-.353-.551,10.059,10.059,0,0,1-1.7-.676v-1.3A2.492,2.492,0,0,1,8.393,17.7Z', 'M18.781,12.271h0a1.45,1.45,0,0,0-2.562,0l-5.055,9.634a1.433,1.433,0,0,0,.048,1.409A1.457,1.457,0,0,0,12.444,24H22.555a1.459,1.459,0,0,0,1.234-.687,1.434,1.434,0,0,0,.047-1.408ZM16.749,15.5a.75.75,0,1,1,1.5,0v3a.75.75,0,0,1-1.5,0Zm.75,6.75a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22.25Z']],
  EarthSubtract: ['earth-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.967,22.108a.5.5,0,0,0-.339-.206,9.975,9.975,0,0,1-2.987-.914.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.492,4.492,0,0,0,1.266-1.779,7.851,7.851,0,0,1,.264-.965,4.448,4.448,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.54,2.54,0,0,1,1.283.362.5.5,0,0,0,.355.059A7.857,7.857,0,0,1,17.5,9.5a7.972,7.972,0,0,1,5.976,2.7A.3.3,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24a.3.3,0,0,0,.2-.524A7.962,7.962,0,0,1,10.967,22.108Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.25H15a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z']],
  Earth3: ['earth-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.575,5.5a.249.249,0,0,0,.231-.344A9.777,9.777,0,0,0,12.133.427a.25.25,0,0,0-.266,0A9.777,9.777,0,0,0,8.194,5.156a.249.249,0,0,0,.231.344Z', 'M18.465,11.009a.25.25,0,0,0,.25.241h4.978a.248.248,0,0,0,.184-.081.252.252,0,0,0,.065-.19,11.888,11.888,0,0,0-.98-3.83A.25.25,0,0,0,22.733,7h-4.46a.25.25,0,0,0-.244.3A21.812,21.812,0,0,1,18.465,11.009Z', 'M16.715,11.25a.254.254,0,0,0,.181-.077.251.251,0,0,0,.069-.184,19.436,19.436,0,0,0-.51-3.8A.248.248,0,0,0,16.213,7H7.787a.249.249,0,0,0-.242.191,19.436,19.436,0,0,0-.51,3.8.251.251,0,0,0,.25.261Z', 'M8.425,18.5a.249.249,0,0,0-.231.344,9.777,9.777,0,0,0,3.674,4.729.249.249,0,0,0,.265,0,9.773,9.773,0,0,0,3.674-4.729.25.25,0,0,0-.232-.344Z', 'M7.285,12.75a.251.251,0,0,0-.25.26,19.437,19.437,0,0,0,.51,3.8A.249.249,0,0,0,7.787,17h8.426a.251.251,0,0,0,.243-.191,19.518,19.518,0,0,0,.509-3.8.251.251,0,0,0-.25-.261Z', 'M.058,10.979a.25.25,0,0,0,.249.271H5.285a.249.249,0,0,0,.25-.24A21.812,21.812,0,0,1,5.971,7.3a.246.246,0,0,0-.05-.209A.248.248,0,0,0,5.727,7H1.267a.25.25,0,0,0-.229.149A11.888,11.888,0,0,0,.058,10.979Z', 'M5.535,12.991a.25.25,0,0,0-.25-.241H.307a.248.248,0,0,0-.184.081.252.252,0,0,0-.065.19,11.9,11.9,0,0,0,.98,3.83A.25.25,0,0,0,1.267,17h4.46a.25.25,0,0,0,.244-.3A21.812,21.812,0,0,1,5.535,12.991Z', 'M6.52,18.668a.251.251,0,0,0-.236-.168H2.4a.25.25,0,0,0-.2.394,12.026,12.026,0,0,0,6.669,4.684.25.25,0,0,0,.251-.409A12.887,12.887,0,0,1,6.52,18.668Z', 'M17.716,18.5a.251.251,0,0,0-.236.168,12.887,12.887,0,0,1-2.594,4.5.25.25,0,0,0,.251.409,12.026,12.026,0,0,0,6.669-4.684.25.25,0,0,0-.2-.394Z', 'M6.284,5.5a.251.251,0,0,0,.236-.168A12.887,12.887,0,0,1,9.114.831.25.25,0,0,0,8.863.422,12.026,12.026,0,0,0,2.194,5.106a.25.25,0,0,0,.2.394Z', 'M23.942,13.021a.25.25,0,0,0-.249-.271H18.715a.25.25,0,0,0-.25.241,21.812,21.812,0,0,1-.436,3.707.25.25,0,0,0,.244.3h4.46a.25.25,0,0,0,.229-.149A11.9,11.9,0,0,0,23.942,13.021Z', 'M17.48,5.332a.251.251,0,0,0,.236.168H21.6a.25.25,0,0,0,.2-.394A12.026,12.026,0,0,0,15.137.422a.25.25,0,0,0-.251.409A12.887,12.887,0,0,1,17.48,5.332Z']],
  EarthPin2: ['earth-pin-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A9.511,9.511,0,0,0,2.5,9.5c0,6.547,6.538,12.488,8.541,14.153a1.5,1.5,0,0,0,1.917,0c2-1.665,8.542-7.608,8.542-14.154A9.511,9.511,0,0,0,12,0Zm0,16A6.493,6.493,0,0,1,8.415,4.089a.5.5,0,0,1,.776.417V7.938a.814.814,0,0,1-.488.746A1.219,1.219,0,0,0,7.971,9.8v.813a1.22,1.22,0,0,0,2.3.564,1.051,1.051,0,0,1,.93-.564h2.46a.814.814,0,0,0,.814-.813l.023-1.66a.812.812,0,0,0-.813-.813H13.28a.814.814,0,0,1-.813-.814L12.484,6a1.008,1.008,0,0,1,1.008-.992A1.008,1.008,0,0,0,14.5,4a.318.318,0,0,1,.463-.283A6.5,6.5,0,0,1,12,16Z']],
  Earth1: ['earth-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,12A12,12,0,1,0,12,24c.021,0,.041,0,.062,0s.042,0,.063,0A11.888,11.888,0,0,0,24,12.125c0-.021,0-.042,0-.063S24,12.021,24,12Zm-2,0a9.862,9.862,0,0,1-.359,2.633.5.5,0,0,1-.681.326,3.484,3.484,0,0,1-1.517-1.268l-2.218-3.328a2.5,2.5,0,0,0-2.08-1.113h-.433a2.75,2.75,0,1,1,0-5.5h2.772a.5.5,0,0,1,.289.092A9.993,9.993,0,0,1,22,12ZM2.179,10.155a.5.5,0,0,1,.491-.4H7.007a3.477,3.477,0,0,1,2.475,1.025L10.6,11.9a3.5,3.5,0,0,1,.14,4.8L9.381,18.229a2.5,2.5,0,0,0-.631,1.662v.827a.5.5,0,0,1-.7.458A10,10,0,0,1,2,12,9.765,9.765,0,0,1,2.179,10.155Z']],
  EarthBlock: ['earth-block', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.7,21.651a.491.491,0,0,0-.334-.217,9.748,9.748,0,0,1-2.9-.934V19.221a2.444,2.444,0,0,1,.874-1.878A4.409,4.409,0,0,0,5.508,9.555H2.337a9.783,9.783,0,0,1,15.068-5.88H14.083a2.7,2.7,0,0,0,0,5.39,2.515,2.515,0,0,1,1.491.5.5.5,0,0,0,.374.089,7.805,7.805,0,0,1,7.027,2.364.383.383,0,0,0,.663-.262A11.76,11.76,0,1,0,7.312,22.6l.156.078v-.021a11.683,11.683,0,0,0,4.41.866.189.189,0,0,0,.127-.329A7.928,7.928,0,0,1,10.7,21.651Z', 'M17.267,10.77a6.615,6.615,0,1,0,6.615,6.615A6.623,6.623,0,0,0,17.267,10.77Zm-3.876,8.809a.493.493,0,0,1-.359-.279,4.576,4.576,0,0,1-.42-1.915,4.66,4.66,0,0,1,4.655-4.655,4.581,4.581,0,0,1,1.916.42.49.49,0,0,1,.142.792l-5.5,5.5A.492.492,0,0,1,13.391,19.579Zm3.876,2.461a4.58,4.58,0,0,1-1.915-.42.487.487,0,0,1-.278-.359.493.493,0,0,1,.136-.433l5.5-5.5a.49.49,0,0,1,.792.142,4.591,4.591,0,0,1,.419,1.915A4.66,4.66,0,0,1,17.267,22.04Z']],
  EarthCheck: ['earth-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.967,22.108a.5.5,0,0,0-.339-.206,9.975,9.975,0,0,1-2.987-.914.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.492,4.492,0,0,0,1.266-1.779,7.851,7.851,0,0,1,.264-.965,4.448,4.448,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.54,2.54,0,0,1,1.283.362.5.5,0,0,0,.355.059A7.857,7.857,0,0,1,17.5,9.5a7.972,7.972,0,0,1,5.976,2.7A.3.3,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24a.3.3,0,0,0,.2-.524A7.962,7.962,0,0,1,10.967,22.108Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm3.274,5.2-2.905,3.874a1.489,1.489,0,0,1-1.1.6c-.036,0-.072,0-.108,0a1.493,1.493,0,0,1-1.058-.442l-1.5-1.5a.75.75,0,0,1,1.061-1.06l1.1,1.094a.5.5,0,0,0,.753-.054l2.559-3.412a.75.75,0,1,1,1.2.9Z']],
  EarthHeart: ['earth-heart', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.163,21.9a.5.5,0,0,0-.4-.151c-.253.021-.507.033-.765.033a9.821,9.821,0,0,1-4.456-1.071V19.419a2.468,2.468,0,0,1,.884-1.9,4.429,4.429,0,0,0,1.094-1.4,5.008,5.008,0,0,1,.485-2.14,4.453,4.453,0,0,0-4.443-4.33h-3.2A9.884,9.884,0,0,1,17.585,3.713H14.228a2.723,2.723,0,1,0,0,5.446,2.577,2.577,0,0,1,2.2,1.245c0,.006.45.751.751,1.25a.5.5,0,0,0,.676.171,4.954,4.954,0,0,1,5.523.307.314.314,0,0,0,.5-.251A11.881,11.881,0,1,0,7.387,22.831l.157.077v-.02A11.824,11.824,0,0,0,12,23.763a11.476,11.476,0,0,0,1.74-.135.495.495,0,0,0,.282-.832Z', 'M23.512,14.544a3.489,3.489,0,0,0-5.59-.907l-.127.127a.5.5,0,0,1-.7,0l-.127-.127a3.491,3.491,0,0,0-4.944,4.929l5.064,5.282a.5.5,0,0,0,.714,0l5.056-5.275A3.486,3.486,0,0,0,23.512,14.544Z']],
  EarthModel2: ['earth-model-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.927,18.87a10.916,10.916,0,0,0,5.313-2.931,1,1,0,1,0-1.414-1.414A9,9,0,0,1,7.1,1.8,1,1,0,0,0,5.684.382,10.98,10.98,0,0,0,11.44,18.958a.5.5,0,0,1,.374.678L11.03,21.6a.5.5,0,0,1-.464.315H7.212a1,1,0,0,0,0,2h13a1,1,0,1,0,0-2H16.858a.5.5,0,0,1-.464-.315l-.821-2.053a.5.5,0,0,1,.354-.673Z', 'M13.712,15.661a7.75,7.75,0,1,0-7.75-7.75A7.759,7.759,0,0,0,13.712,15.661ZM9.662,6.148l.623-.692a1.4,1.4,0,0,1,1.479-.392A.931.931,0,0,0,12.75,4.8L13.813,3.62l1.705-1.9a.5.5,0,0,1,.546-.135,6.7,6.7,0,0,1,2.16,1.3c.12.107.233.219.341.333a.5.5,0,0,1,.01.674L16.629,6.1a.929.929,0,0,0,.07,1.314l.346.312a.931.931,0,0,1,.07,1.315l-1.291,1.4a.93.93,0,0,1-1.315.07L12.778,8.949l-.346-.311-.017-.015a1.2,1.2,0,0,0-1.224-.233A1.4,1.4,0,0,1,9.662,6.148Z']],
  EarthQuestion: ['earth-question', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.967,22.108a.5.5,0,0,0-.339-.206,9.975,9.975,0,0,1-2.987-.914.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.482,4.482,0,0,0,1.264-1.775,7.868,7.868,0,0,1,.266-.972,4.423,4.423,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.527,2.527,0,0,1,1.282.362.5.5,0,0,0,.354.058A7.874,7.874,0,0,1,17.5,9.5a7.97,7.97,0,0,1,5.977,2.7A.3.3,0,0,0,24,12,12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24a.3.3,0,0,0,.2-.524A7.968,7.968,0,0,1,10.967,22.108Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm0,11.5a1,1,0,1,1,1-1A1,1,0,0,1,17.5,22.5Zm1.049-4.219a.5.5,0,0,0-.3.458v.011a.75.75,0,0,1-1.5,0V18.2a1.256,1.256,0,0,1,.988-1.221,1.125,1.125,0,1,0-1.363-1.1.75.75,0,0,1-1.5,0,2.625,2.625,0,1,1,3.674,2.406Z']],
  EarthSetting: ['earth-setting', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.207 17.100 A1.485 1.485 0 1 0 19.177 17.100 A1.485 1.485 0 1 0 16.207 17.100 Z', 'M22.425,17.41a.457.457,0,0,1,0-.619l.977-1.055a1.764,1.764,0,0,0-1.683-2.923l-1.4.323a.449.449,0,0,1-.528-.308l-.42-1.378a1.757,1.757,0,0,0-3.365,0l-.419,1.378a.448.448,0,0,1-.528.308l-1.4-.323a1.764,1.764,0,0,0-1.684,2.923l.978,1.055a.459.459,0,0,1,0,.619l-.978,1.054a1.765,1.765,0,0,0,1.684,2.924l1.4-.324a.446.446,0,0,1,.529.308l.419,1.378a1.757,1.757,0,0,0,3.365,0l.42-1.378a.448.448,0,0,1,.528-.308l1.4.324A1.765,1.765,0,0,0,23.4,18.464Zm-4.733,2.661a2.971,2.971,0,1,1,2.97-2.971A2.974,2.974,0,0,1,17.692,20.071Z', 'M14.589,23.182l0-.01A.5.5,0,0,0,14,22.834a3.279,3.279,0,0,1-.751.087,3.175,3.175,0,0,1-2.4-1.089.494.494,0,0,0-.3-.162,9.9,9.9,0,0,1-3-.959V19.419a2.47,2.47,0,0,1,.883-1.9A4.455,4.455,0,0,0,5.564,9.654H2.36A9.884,9.884,0,0,1,17.584,3.713H14.227a2.723,2.723,0,0,0,0,5.446,2.562,2.562,0,0,1,1.319.376,3.233,3.233,0,0,1,5.248,1.483l0,.011a.5.5,0,0,0,.585.337h0a3.324,3.324,0,0,1,.749-.087,3.168,3.168,0,0,1,1.05.179.495.495,0,0,0,.658-.505A11.88,11.88,0,1,0,7.387,22.831l.157.077v-.02a11.656,11.656,0,0,0,6.851.621.258.258,0,0,0,.194-.327Z']],
  EarthLocate: ['earth-locate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.608,21.684a.5.5,0,0,0-.545-.165,9.936,9.936,0,0,1-7.423-.531.25.25,0,0,1-.14-.225v-1.15A2.5,2.5,0,0,1,8.392,17.7,4.5,4.5,0,0,0,5.5,9.75H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.524,2.524,0,0,1,.978.2.5.5,0,0,0,.45-.033A6.468,6.468,0,0,1,22.9,9.81a.5.5,0,0,0,.789-.511A12,12,0,1,0,7.341,23.059l.159.078v-.02a11.928,11.928,0,0,0,8.566.17.5.5,0,0,0,.209-.795C16.063,22.245,15.839,21.974,15.608,21.684Z', 'M19,10a5.006,5.006,0,0,0-5,5c0,3.171,4.457,7.664,4.647,7.854a.5.5,0,0,0,.707,0C19.544,22.664,24,18.171,24,15A5.006,5.006,0,0,0,19,10Zm0,6.75A1.75,1.75,0,1,1,20.75,15,1.752,1.752,0,0,1,19,16.75Z']],
  EarthMove: ['earth-move', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,4.992a7,7,0,0,0,0,14h0a7,7,0,0,0,0-14Zm.193,11.964a.25.25,0,0,1-.386,0,8.091,8.091,0,0,1-1.255-2.121.248.248,0,0,1,.025-.233.251.251,0,0,1,.207-.11h2.432a.25.25,0,0,1,.232.343A8.074,8.074,0,0,1,12.193,16.956Zm-1.9-3.964a.249.249,0,0,1-.248-.222A6.986,6.986,0,0,1,10,11.992a7.206,7.206,0,0,1,.044-.777.25.25,0,0,1,.249-.223h3.414a.249.249,0,0,1,.248.223,6.739,6.739,0,0,1,0,1.555.248.248,0,0,1-.248.222Zm-3.793-1a5.38,5.38,0,0,1,.06-.787.25.25,0,0,1,.247-.213H8.284a.25.25,0,0,1,.249.272c-.02.236-.033.478-.033.728s.013.493.033.729a.25.25,0,0,1-.249.271H6.807a.25.25,0,0,1-.247-.213A5.369,5.369,0,0,1,6.5,11.992Zm5.307-4.963A.245.245,0,0,1,12,6.938a.248.248,0,0,1,.193.091,8.1,8.1,0,0,1,1.255,2.12.25.25,0,0,1-.232.343H10.784a.25.25,0,0,1-.232-.343A8.083,8.083,0,0,1,11.807,7.029Zm3.66,4.235a.25.25,0,0,1,.249-.272h1.477a.25.25,0,0,1,.247.213,5.191,5.191,0,0,1,0,1.574.249.249,0,0,1-.247.213H15.716a.25.25,0,0,1-.249-.271c.02-.236.033-.478.033-.729S15.487,11.5,15.467,11.264Zm1.211-2.153a.25.25,0,0,1-.213.381H15.338a.25.25,0,0,1-.239-.177,9.329,9.329,0,0,0-.746-1.771.251.251,0,0,1,.343-.338A5.542,5.542,0,0,1,16.678,9.111ZM9.3,7.206a.251.251,0,0,1,.343.338A9.329,9.329,0,0,0,8.9,9.315a.25.25,0,0,1-.239.177H7.535a.249.249,0,0,1-.212-.381A5.531,5.531,0,0,1,9.3,7.206ZM7.322,14.874a.253.253,0,0,1,0-.254.25.25,0,0,1,.218-.128H8.662a.25.25,0,0,1,.239.178,9.318,9.318,0,0,0,.746,1.77.25.25,0,0,1-.343.338A5.53,5.53,0,0,1,7.322,14.874Zm7.374,1.9a.251.251,0,0,1-.343-.338,9.318,9.318,0,0,0,.746-1.77.25.25,0,0,1,.239-.178h1.127a.25.25,0,0,1,.212.382A5.52,5.52,0,0,1,14.7,16.778Z', 'M9.13,2.655a.5.5,0,0,0,.37.837h5a.5.5,0,0,0,.37-.837L12.74.319a1.035,1.035,0,0,0-1.48,0Z', 'M23.673,11.253l-2.336-2.13a.5.5,0,0,0-.837.369v5a.5.5,0,0,0,.3.458.512.512,0,0,0,.2.042.5.5,0,0,0,.337-.13l2.336-2.13a1,1,0,0,0,0-1.479Z', 'M14.5,20.492h-5a.5.5,0,0,0-.37.837l2.13,2.337a1,1,0,0,0,1.48,0l2.13-2.337a.5.5,0,0,0-.37-.837Z', 'M3.2,9.035a.5.5,0,0,0-.539.088L.327,11.253a1,1,0,0,0,0,1.479l2.336,2.13a.5.5,0,0,0,.337.13.512.512,0,0,0,.2-.042.5.5,0,0,0,.3-.458v-5A.5.5,0,0,0,3.2,9.035Z']],
  EarthRemove: ['earth-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.907,22.022a.254.254,0,0,0-.174-.106,9.974,9.974,0,0,1-3.092-.928.25.25,0,0,1-.141-.225v-1.15A2.492,2.492,0,0,1,8.393,17.7a4.492,4.492,0,0,0,1.266-1.779,7.851,7.851,0,0,1,.264-.965,4.448,4.448,0,0,0,.077-.7,4.505,4.505,0,0,0-4.5-4.5H2.584a.25.25,0,0,1-.241-.314A9.982,9.982,0,0,1,16.889,3.282a.25.25,0,0,1-.122.468H14.25a2.75,2.75,0,0,0,0,5.5,2.554,2.554,0,0,1,1.358.408.246.246,0,0,0,.187.032,7.924,7.924,0,0,1,7.764,2.6A.25.25,0,0,0,24,12.138c0-.046,0-.092,0-.138A12,12,0,1,0,7.341,23.059l.159.078v-.02A11.927,11.927,0,0,0,12,24l.137,0a.25.25,0,0,0,.156-.44A7.969,7.969,0,0,1,10.907,22.022Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm1.414,6.854,1.237,1.237a.75.75,0,1,1-1.06,1.06l-1.237-1.237a.5.5,0,0,0-.708,0l-1.237,1.237a.75.75,0,1,1-1.06-1.06l1.237-1.237a.5.5,0,0,0,0-.708l-1.237-1.237a.75.75,0,0,1,1.06-1.06l1.237,1.237a.5.5,0,0,0,.708,0l1.237-1.237a.75.75,0,1,1,1.06,1.06l-1.237,1.237A.5.5,0,0,0,18.914,17.854Z']]
};
exports["default"] = _default;